import _asyncToGenerator from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { DataSource } from '../datasource';
import { urlChunkIterator } from '../iterators/url_chunk_iterator';
import { isLocalPath } from '../util/source_util';
import { FileDataSource } from './file_data_source';
/*
 * Represents a URL readable as a stream of binary data chunks.
 */

export var URLDataSource = /*#__PURE__*/function (_DataSource) {
  _inherits(URLDataSource, _DataSource);

  var _super = _createSuper(URLDataSource);

  /**
   * Create a `URLDataSource`.
   *
   * @param url A source URL string, or a `Request` object.
   * @param options Options passed to the underlying `FileChunkIterator`s,
   *   such as {chunksize: 1024}.
   */
  function URLDataSource(url) {
    var _this;

    var fileOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, URLDataSource);

    _this = _super.call(this);
    _this.url = url;
    _this.fileOptions = fileOptions;
    return _this;
  } // TODO(soergel): provide appropriate caching options.  Currently this
  // will download the URL anew for each call to iterator().  Since we have
  // to treat the downloaded file as a blob/buffer anyway, we may as well retain
  // it-- but that raises GC issues.  Also we may want a persistent disk cache.


  _createClass(URLDataSource, [{
    key: "iterator",
    value: function () {
      var _iterator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isLocalPath(this.url)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", new FileDataSource(this.url, this.fileOptions).iterator());

              case 4:
                return _context.abrupt("return", urlChunkIterator(this.url, this.fileOptions));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function iterator() {
        return _iterator.apply(this, arguments);
      }

      return iterator;
    }()
  }]);

  return URLDataSource;
}(DataSource);